import api from "@/api/client";

export type ReportGroup = {
  key: string;
  label: string;
  count: number;
  subgroups?: ReportGroup[];
};

export type ReportBucket = {
  label: string;
  start: string;
  end: string;
  raw_period_key: string;
  bucket_size_days: number;
  totals: { count: number };
  groups?: ReportGroup[];
};

export type ReportResponse = {
  period: "day" | "week" | "month";
  timezone: string;
  anchor_date: string;
  from: string;
  to: string;
  group_by: string[];
  bucket_count: number;
  bucket_size_days: number;
  buckets: ReportBucket[];
};

type ReportParams = {
  period: "day" | "week" | "month";
  groupBy: string[];
  date: string; // YYYY-MM-DD
  agents?: (number | string)[];
  statuses?: string[];
};

export async function fetchReport(params: ReportParams): Promise<ReportResponse> {
  const { period, groupBy, date, agents, statuses } = params;
  const searchParams = new URLSearchParams();
  searchParams.set("period", period);
  searchParams.set("group_by", groupBy.join(","));
  searchParams.set("date", date);
  agents?.forEach((a) => searchParams.append("agents", String(a)));
  statuses?.forEach((s) => searchParams.append("statuses", s));

  const res = await api.get(`/admin/reports?${searchParams.toString()}`);
  return res.data;
}
